(function() {
    var location_items = ['kraj', 'okres', 'obec', 'cobce', 'ulice', 'objekt', 'cisor_hod', 'cisor_pis', 'psc', 'mcast', 'pobvod', 'par_cis', 'par_cis_typ', 'par_cis_druh', 'ku', 'ku_kod'];
    var filter = false;
    let $input_ruian, values, $errorIcon, $okIcon, $elements;

    var PRLocality = {
        options: {
            multi: false,
        },
        initialize: function($input, options) {
            if (typeof options !== "undefined") {
                $.each(options, function(key, value) {
                    if (typeof PRLocality.options[key] !== "undefined") {
                        PRLocality.options[key] = value;
                    }
                });
            }

            filter          = $input.data('locality-filter') == true;
            $input_ruian    = $('input[name="ruian_kod"]');
            values          = {};

            // nacteme defaultni hodnoty jsouli zadany
            if ($input.data('locality-elements'))
            {
                location_items = [];
                var localityElements = $input.data('locality-elements').split('|');
                for (let i in localityElements) {
                    var localityElementsPart = localityElements[i].split(':');

                    location_items.push(localityElementsPart[0]);
                    if (localityElementsPart[1]) {
                        values[localityElementsPart[0]] = localityElementsPart[1]
                    }
                }
            }

            PRLocality.generateForm($input);
            PRLocality.loadFormData(values);
            PRLocality.createValidIcon($input);

            $input.autocomplete({
                source: function( request, response ) {
                    var apiData = {};
                    apiData['search'] = request.term;
                    apiData['cid'] = window.setting.CID;
                    apiData['version'] = window.setting.VERSION;
                    apiData['locale'] = window.poskiLocale.locale;
                    apiData['country'] = 'cz';
                    apiData['label'] = filter ? 3 : 2;
                    apiData['hash'] = window.setting.API_HASH;
                    if (filter) {
                        apiData['search_level'] = 'UL|CO|MC|OB|OK';
                    }

                    $.ajax( {
                        url: window.setting.API_URL+'/location/v1/search/',
                        dataType: "json",
                        data: apiData,
                        success: function( data ) {
                            response(data.locations);
                        },
                    } );
                    PRLocality.deleteForm();
                },
                html: true,
                minLength: 2,
                select: function( event, ui ) {
                    event.preventDefault();
                    $input.val(ui.item.text_input);
                    PRLocality.generateForm($input);
                    PRLocality.setDataToMultiForm($input, ui.item);
                    PRLocality.setDataToForm($input, ui.item);
                    if (PRLocality.options.multi) {
                        $input.val('');
                    }
                },
                focus: function(event, ui) {
                    event.preventDefault();
                    if (!filter) {
                        $input.val(ui.item.text_input);
                    }
                },
            });

            $('.js-locality-item-delete').on('click', function() {
                $(this).closest('.js-locality-item').remove();
            });

            $('#rozloha').on('change', function() {
                $(this).removeClass('not-edit');
            });
        },
        createValidIcon: function($input) {
            $errorIcon = $('<i/>').addClass('fa fa-exclamation-circle js-locality-valid-error');
            $okIcon = $('<i/>').addClass('fa fa-check-circle js-locality-valid-ok').css({'color': 'green'});

            let $prepend = $('<div/>').addClass('input-group-addon').css({'border-radius': '0','border-left': '0'})
                .append($errorIcon)
                .append($okIcon);

            if ($input_ruian.val() == '')
                $okIcon.hide();
            else
                $errorIcon.hide();

            $input.filter('.js-locality-valid').after($prepend);
        },
        deleteForm: function() {
            $errorIcon.css({'color': 'red'}).show();
            $okIcon.hide();
            $('.js-locality-hidden').val('');
            $input_ruian.val('');
        },
        generateForm: function($input) {
            if ($('.js-locality-hidden').length === 0)
            {
                $('.js-locality-hidden').remove();

                for (let i in location_items)
                {
                    const $hidden = $('<input/>').attr('type', 'hidden').attr('name', location_items[i]).addClass('js-locality-hidden').addClass('js-locality-'+location_items[i]).val('');
                    $input.after($hidden);
                }
            }
            if ($('#rozloha').length !== 0 && !$('#rozloha').val()) {
                $('#rozloha').addClass('not-edit');
            }
        },
        setDataToMultiForm: function($input, item) {
            if (PRLocality.options.multi)
            {
                $input.prop('name', '');
                var onSuccess = function(data)
                {
                    var $localityItems = $('.js-locality-items');
                    if ($localityItems.length === 0)
                    {
                        $localityItems = $('<div/>').addClass('js-locality-items');
                        $input.before($localityItems);
                    }

                    var id = $localityItems.find('.js-locality-item').length !== 0 ? (parseInt($localityItems.find('.js-locality-item').last().data('id'))+1) : 0;

                    var $item = $('<div/>').addClass('js-locality-item').data('id', id);
                    $localityItems.append($item);



                    for (let i in location_items)
                    {
                        let $hidden = $('<input/>').attr('type', 'hidden').attr('name', 'lokalita['+id+']['+location_items[i]+']').val(data.location[location_items[i]]);
                        $item.append($hidden);
                    }

                    let $hidden = $('<input/>').attr('type', 'hidden').attr('name', 'lokalita['+id+'][ruian_kod]').val(data.location['ruian_kod']);
                    $item.append($hidden);

                    var title = '';
                    if (data.location.okres) {
                        title = data.location.okres;
                    }
                    if (data.location.obec) {
                        title = title + ', ' + data.location.obec;
                    }
                    if (data.location.ulice) {
                        title = title + ' ' + data.location.ulice;
                        if (data.location.cisor_hod) {
                            title = title + ' ' + data.location.cisor_hod;
                        }
                    }
                    else if (data.location.ku) {
                        if (data.location.obec != data.location.ku) {
                            title = title + ' ' + data.location.ku;
                        }
                        if (data.location.par_cis) {
                            title = title + ' ' + data.location.par_cis;
                        }
                    }

                    var $deleteBtn = $('<span/>').addClass('js-locality-item-delete').html('<i class="fa fa-times" aria-hidden="true"></i>');

                    $item.append($('<span/>').addClass('item-lokalita').text(title));
                    $item.append($deleteBtn);
                    $item.wrap('<div class="item-lokalita-obal" />');

                    $deleteBtn.on('click', function() {
                        $(this).closest('.js-locality-item').remove();
                    });
                };
                PRLocality.setRuianData(item, onSuccess);
            }
        },
        loadFormData: function(values) {
            for (let key in values)
            {
                $('.js-locality-hidden').filter('.js-locality-'+key).val(values[key]);
            }
        },
        setRuianData: function(item, onSuccess) {
            var apiData = {};
            apiData['ruian_kod'] = item.ruian_kod;
            apiData['cid'] = window.setting.CID;
            apiData['version'] = window.setting.VERSION;
            apiData['locale'] = window.poskiLocale.locale;
            apiData['hash'] = window.setting.API_HASH;

            $.ajax({
                url: window.setting.API_URL+'/location/v1/get/',
                dataType: "json",
                data: apiData,
                success: function( data )
                {
                    onSuccess(data);
                },
            });
        },
        setDataToForm: function($input, item) {
            var onSuccess = function(data)
            {
                $elements = $('.js-locality-hidden');
                for (let i in location_items)
                {
                    if (data.location[location_items[i]])
                    {
                        $elements.filter('.js-locality-'+location_items[i]).val(data.location[location_items[i]]);
                    }
                }
                $input_ruian.val(data.location['ruian_kod']);

                $errorIcon.hide();
                $okIcon.show();
                $input.trigger('change-filter');

                if ($('#rozloha').length !== 0 && (!$('#rozloha').val() || $('#rozloha').is('.not-edit'))) {
                    $('#rozloha').val($('#rozloha').val() ? parseInt($('#rozloha').val()) + data.location.vymera : data.location.vymera);
                }
            };
            PRLocality.setRuianData(item, onSuccess);
        },
    };
    window.PRLocality = PRLocality;
}());